import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import {
  FETCH_PATIENT_INSURANCE_SUCCESS,
  UPDATE_PATIENT_INSURANCE_SUCCESS,
  CHECK_PATIENT_INSURANCE_ELIGIBILITY,
  CHECK_PATIENT_INSURANCE_ELIGIBILITY_SUCCESS,
  CHECK_PATIENT_INSURANCE_ELIGIBILITY_FAIL,
} from 'redux/modules/patientsInsurance';
import {
  UPDATE_PATIENT_SUCCESS,
  ADD_PATIENT_RESOURCE_SUCCESS,
  REMOVE_PATIENT_RESOURCE_SUCCESS,
  CHANGE_PATIENT_RESOURCE_SUCCESS,
} from 'redux/modules/patients';
import { CREATE_PATIENT_VITALS_SUCCESS } from 'redux/modules/patientsVitals';
import { FETCH_ORDERS_LINES_CLAIMS_SUCCESS } from 'redux/modules/ordersLinesClaims';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_ARCHIVE_ORDERS = 'FETCH_ARCHIVE_ORDERS';
export const FETCH_ARCHIVE_ORDERS_SUCCESS = 'FETCH_ARCHIVE_ORDERS_SUCCESS';
export const FETCH_ARCHIVE_ORDERS_FAIL = 'FETCH_ARCHIVE_ORDERS_FAIL';
export const CLEAR_ARCHIVE_ORDERS = 'CLEAR_ORDERS';
export const FETCH_ARCHIVE_ORDER = 'FETCH_ARCHIVE_ORDER';
export const FETCH_ARCHIVE_ORDER_SUCCESS = 'FETCH_ARCHIVE_ORDER_SUCCESS';
export const FETCH_ARCHIVE_ORDER_FAIL = 'FETCH_ARCHIVE_ORDER_FAIL';
export const ARCHIVE_ORDER = 'ARCHIVE_ORDER';
export const ARCHIVE_ORDER_SUCCESS = 'ARCHIVE_ORDER_SUCCESS';
export const ARCHIVE_ORDER_FAIL = 'ARCHIVE_ORDER_FAIL';
export const UNARCHIVE_ORDER = 'UNARCHIVE_ORDER';
export const UNARCHIVE_ORDER_SUCCESS = 'UNARCHIVE_ORDER_SUCCESS';
export const UNARCHIVE_ORDER_FAIL = 'UNARCHIVE_ORDER_FAIL';
export const DELETE_ARCHIVE_ORDER = 'DELETE_ARCHIVE_ORDER';
export const DELETE_ARCHIVE_ORDER_SUCCESS = 'DELETE_ARCHIVE_ORDER_SUCCESS';
export const DELETE_ARCHIVE_ORDER_FAIL = 'DELETE_ARCHIVE_ORDER_FAIL';

// Reducer
export default function archiveOrdersReducer(state = {
  data: [], count: 0, loading: 0, contextFiltersOptions: null,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_ARCHIVE_ORDERS:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ARCHIVE_ORDERS_SUCCESS: {
      const newData = payload.data.map(dataItem => ({
        ...dataItem,
        'Is Archive': true,
        'Order Line': dataItem['Order Line'].map(item => ({
          ...item,
          'Transmission Method': dataItem['Transmission Method'],
          'Order ID': item['Order ID'] || dataItem.ID,
        })),
        Patient: {
          ...dataItem.Patient,
          Diagnosis: dataItem.Patient.Diagnosis || [],
          Documents: dataItem.Patient.Documents || [],
          'Credit Card': dataItem.Patient['Credit Card'] || [],
          'Insurance Information': dataItem.Patient['Insurance Information'] || [],
          Prescriber: dataItem.Patient.Prescriber || [],
          'Referral Source': dataItem.Patient['Referral Source'] || [],
          'Sales Representative': dataItem.Patient['Sales Representative'] || [],
          Vitals: dataItem.Patient.Vitals || [],
        },
      }));
      return {
        ...state,
        ...payload,
        ...payload.push ? { data: [
          ...state.data.slice(0, state.data.length),
          ...newData.slice(0, payload.data.length),
        ] } : { data: newData },
        ...payload.contextFiltersOptions && Object.keys(payload.contextFiltersOptions).length > 0 ? {
          contextFiltersOptions: {
            users: Object.keys(payload.contextFiltersOptions['Assigned User ID'])
              .map(key => ({
                'First Name': payload.contextFiltersOptions['Assigned User ID'][key].first_name,
                'Last Name': payload.contextFiltersOptions['Assigned User ID'][key].last_name,
                ID: Number(key),
                count: payload.contextFiltersOptions['Assigned User ID'][key].count,
              })),
            drivers: Object.keys(payload.contextFiltersOptions['Driver ID'])
              .map(key => ({
                'First Name': Number(key)
                  ? payload.contextFiltersOptions['Driver ID'][key].first_name
                  : 'Driver',
                'Last Name': Number(key)
                  ? payload.contextFiltersOptions['Driver ID'][key].last_name
                  : 'not assigned',
                ID: Number(key) ? Number(key) : null,
                count: payload.contextFiltersOptions['Driver ID'][key].count,
              })),
            statuses: Object.keys(payload.contextFiltersOptions['Workflow Status ID'])
              .map(key => ({
                name: payload.contextFiltersOptions['Workflow Status ID'][key].workflow_status_name,
                ID: Number(key),
                count: payload.contextFiltersOptions['Workflow Status ID'][key].count,
              })),
            orderLineTypes: Object.keys(payload.contextFiltersOptions['Line Type'])
              .map(key => ({
                name: key, count: payload.contextFiltersOptions['Line Type'][key].count,
              })),
            insurances: Object.keys(payload.contextFiltersOptions['Insurance Info ID'])
              .filter(key => key !== 'null')
              .map(key => ({
                'Payer Name': key !== 'null'
                  ? payload.contextFiltersOptions['Insurance Info ID'][key].payer_name
                  : 'Self Payer',
                ID: Number(key),
                count: payload.contextFiltersOptions['Insurance Info ID'][key].count,
              })),
            cities: Object.keys(payload.contextFiltersOptions.City)
              .map((key) => ({
                name: key === 'null' ? 'No Patient Address' : key,
                count: payload.contextFiltersOptions.City[key].count,
              })),
            sales: Object.keys(payload.contextFiltersOptions['Sales Representative ID'])
              .map(key => ({
                'First Name': Number(key)
                  ? payload.contextFiltersOptions['Sales Representative ID'][key].first_name
                  : 'Sales',
                'Last Name': Number(key)
                  ? payload.contextFiltersOptions['Sales Representative ID'][key].last_name
                  : 'not assigned',
                ID: Number(key) ? Number(key) : null,
                count: payload.contextFiltersOptions['Sales Representative ID'][key].count,
              })),
            referralSources: Object.keys(payload.contextFiltersOptions['Referral Source ID'])
              .map(key => ({
                name: Number(key)
                  ? payload.contextFiltersOptions['Referral Source ID'][key].name
                  : 'Referral not assigned',
                ID: Number(key) ? Number(key) : null,
                count: payload.contextFiltersOptions['Referral Source ID'][key].count,
              })),
            prescribers: Object.keys(payload.contextFiltersOptions['Prescriber ID'])
            .map(key => ({
              'First Name': Number(key)
                  ? payload.contextFiltersOptions['Prescriber ID'][key].first_name
                  : 'Prescriber',
              'Last Name': Number(key)
                ? payload.contextFiltersOptions['Prescriber ID'][key].last_name
                : 'not assigned',
              ID: Number(key) ? Number(key) : null,
              count: payload.contextFiltersOptions['Prescriber ID'][key].count,
            })),
            hcpcsCodes: Object.keys(payload.contextFiltersOptions['HCPC S Code ID'])
              .map(key => ({
                name: payload.contextFiltersOptions['HCPC S Code ID'][key].name,
                ID: Number(key),
                count: payload.contextFiltersOptions['HCPC S Code ID'][key].count,
              })),
            watchers: Object.keys(payload.contextFiltersOptions['Watcher ID'])
              .map(key => ({
                'First Name': payload.contextFiltersOptions['Watcher ID'][key].first_name || 'No',
                'Last Name': payload.contextFiltersOptions['Watcher ID'][key].last_name || 'Watcher',
                ID: Number(key),
                count: payload.contextFiltersOptions['Watcher ID'][key].count,
              })),
          },
        } : {
          contextFiltersOptions: state.contextFiltersOptions,
        },
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_ARCHIVE_ORDERS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_ARCHIVE_ORDERS:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case FETCH_ARCHIVE_ORDER:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ARCHIVE_ORDER_SUCCESS:
      let isPresent = false;
      let newCount = state.count;
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        isPresent = true;
        return {
          ...dataItem,
          ...payload,
          'Order Line': payload['Order Line'].map(item => ({
            ...item,
            'Transmission Method': payload['Transmission Method'],
          })),
        };
      });
      if (!isPresent) {
        newCount += 1;
        newData.push({
          ...payload,
          'Order Line': payload['Order Line'].map(item => ({
            ...item,
            'Transmission Method': payload['Transmission Method'],
          })),
        });
      }
      return {
        ...state,
        count: newCount,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_ARCHIVE_ORDER_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PATIENT_INSURANCE_SUCCESS:
    case UPDATE_PATIENT_INSURANCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Primary Insurance']
          || dataItem.Insurance.length === 0) {
          return dataItem;
        }
        const newInsurances = dataItem.Insurance.map((insurancesItem) => {
          if (insurancesItem.ID !== payload.ID) {
            return insurancesItem;
          }

          return {
            ...insurancesItem,
            ...payload,
          };
        });

        return {
          ...dataItem,
          Insurance: newInsurances,
          ...dataItem['Primary Insurance'].ID === payload.ID ? {
            'Primary Insurance': {
              ...dataItem['Primary Insurance'],
              ...payload,
            },
          } : {},
        };
      });
      return {
        ...state,
        count: state.count,
        data: newData,
      };
    }
    case CHECK_PATIENT_INSURANCE_ELIGIBILITY: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Primary Insurance']
          || dataItem.Insurance.length === 0) {
          return dataItem;
        }
        const newInsurances = dataItem.Insurance.map((insurancesItem) => {
          if (insurancesItem.ID !== payload['Insurance ID']) {
            return insurancesItem;
          }

          return {
            ...insurancesItem,
            'Checking Eligibility': true,
          };
        });
        return {
          ...dataItem,
          Insurance: newInsurances,
          ...dataItem['Primary Insurance'].ID === payload['Insurance ID'] ? {
            'Primary Insurance': {
              ...dataItem['Primary Insurance'],
              'Checking Eligibility': true,
            },
          } : {},
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case CHECK_PATIENT_INSURANCE_ELIGIBILITY_SUCCESS:
    case CHECK_PATIENT_INSURANCE_ELIGIBILITY_FAIL: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Primary Insurance']
          || dataItem.Insurance.length === 0) {
          return dataItem;
        }
        const newInsurances = dataItem.Insurance.map((insurancesItem) => {
          if (insurancesItem.ID !== payload['Insurance ID']) {
            return insurancesItem;
          }

          return {
            ...insurancesItem,
            'Checking Eligibility': false,
          };
        });

        return {
          ...dataItem,
          Insurance: newInsurances,
          ...dataItem['Primary Insurance'].ID === payload['Insurance ID'] ? {
            'Primary Insurance': {
              ...dataItem['Primary Insurance'],
              'Checking Eligibility': false,
            },
          } : {},
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_PATIENT_SUCCESS:
    case ADD_PATIENT_RESOURCE_SUCCESS:
    case CHANGE_PATIENT_RESOURCE_SUCCESS:
    case REMOVE_PATIENT_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.Patient['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        return {
          ...dataItem,
          Patient: payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case CREATE_PATIENT_VITALS_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.Patient['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        const newVitals = [
          ...dataItem.Patient.Vitals.slice(0, dataItem.Patient.Vitals.length),
          payload.Vitals,
        ];
        return {
          ...dataItem,
          Patient: {
            ...dataItem.Patient,
            Vitals: newVitals,
          },
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case FETCH_ORDERS_LINES_CLAIMS_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newOrderLine = dataItem['Order Line'].map((orderLineItem) => {
          const newClaim = payload.data.filter(claimItem =>
            claimItem['Order Line'].map(orderLine => orderLine.ID).indexOf(orderLineItem.ID) !== -1);
          if (newClaim.length === 0) {
            return orderLineItem;
          }
          return {
            ...orderLineItem,
            Claim: newClaim,
          };
        });

        return {
          ...dataItem,
          'Order Line': newOrderLine,
        };
      });
      return {
        ...state,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case DELETE_ARCHIVE_ORDER_SUCCESS: {
      const index = state.data
        .findIndex(item => item.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchArchiveOrders(payload) {
  return { type: FETCH_ARCHIVE_ORDERS, payload };
}

export function fetchArchiveOrdersSuccess(payload) {
  return { type: FETCH_ARCHIVE_ORDERS_SUCCESS, payload };
}

export function fetchArchiveOrdersFail(payload) {
  return { type: FETCH_ARCHIVE_ORDERS_FAIL, payload };
}

export function clearArchiveOrders() {
  return { type: CLEAR_ARCHIVE_ORDERS };
}

export function fetchArchiveOrder(payload) {
  return { type: FETCH_ARCHIVE_ORDER, payload };
}

export function fetchArchiveOrderSuccess(payload) {
  return { type: FETCH_ARCHIVE_ORDER_SUCCESS, payload };
}

export function fetchArchiveOrderFail(payload) {
  return { type: FETCH_ARCHIVE_ORDER_FAIL, payload };
}

export function archiveOrder(payload) {
  return { type: ARCHIVE_ORDER, payload };
}

export function archiveOrderSuccess(payload) {
  return { type: ARCHIVE_ORDER_SUCCESS, payload };
}

export function archiveOrderFail(payload) {
  return { type: ARCHIVE_ORDER_FAIL, payload };
}

export function unarchiveOrder(payload) {
  return { type: UNARCHIVE_ORDER, payload };
}

export function unarchiveOrderSuccess(payload) {
  return { type: UNARCHIVE_ORDER_SUCCESS, payload };
}

export function unarchiveOrderFail(payload) {
  return { type: UNARCHIVE_ORDER_FAIL, payload };
}

export function deleteArchiveOrder(payload) {
  return { type: DELETE_ARCHIVE_ORDER, payload };
}

export function deleteArchiveOrderSuccess(payload) {
  return { type: DELETE_ARCHIVE_ORDER_SUCCESS, payload };
}

export function deleteArchiveOrderFail(payload) {
  return { type: DELETE_ARCHIVE_ORDER_FAIL, payload };
}

let abort;

// Requests
export function requestFetchArchiveOrders({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi(`archive/archive_order/?limit=${limit}&offset=${offset}`);
  abort = request.abort;
  return request.res;
}

export function requestSearchArchiveOrders({ limit, offset, filters = [], sortBy = [] }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('archive/archive_order/search/', 'POST', {
    ...filters ? { filters } : {},
    sort_by: [
      ...sortBy,
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
    show_schema_name: 'dashboard_workflow_schema',
  });
  abort = request.abort;
  return request.res;
}

export function requestFetchArchiveOrder(payload) {
  return callApi(`archive/archive_order/?id=${payload}`);
}

export function requestArchiveOrder(payload) {
  return callApi('archive/archive_process/archive/', 'POST', payload);
}

export function requestUnarchiveOrder(payload) {
  return callApi('archive/archive_process/un_archive/', 'POST', payload);
}

export function requestDeleteArchiveOrder(payload) {
  return callApi(`archive/archive_order/?id=${payload}`, 'DELETE');
}

// Sagas
function* fetchArchiveOrdersSaga(action) {
  const { triggerLoading, filters, sortBy, push } = action.payload;
  try {
    const res = filters || sortBy
      ? yield call(requestSearchArchiveOrders, action.payload)
      : yield call(requestFetchArchiveOrders, action.payload);
    if (res.count === 0) {
      yield put(fetchArchiveOrdersSuccess({
        data: res.data,
        count: res.count,
        contextFiltersOptions: res.next_filter_data || null,
        triggerLoading,
      }));
    } else if (push) {
      yield put(fetchArchiveOrdersSuccess({
        push: true,
        data: res.data,
        count: res.count,
        contextFiltersOptions: res.next_filter_data || null,
        triggerLoading,
      }));
    } else {
      yield put(fetchArchiveOrdersSuccess({
        data: res.data,
        count: res.count,
        contextFiltersOptions: res.next_filter_data || null,
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchArchiveOrdersFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* fetchArchiveOrderSaga(action) {
  const { triggerLoading, ID } = action.payload;
  try {
    const res = yield call(requestFetchArchiveOrder, ID);
    if (res.data.ID) {
      yield put(fetchArchiveOrderSuccess({
        ...res.data,
        triggerLoading,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchArchiveOrderFail({
        triggerLoading,
      }));
    }
  } catch (err) {
    yield put(fetchArchiveOrderFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* archiveOrderSaga(action) {
  const { triggerLoading, values } = action.payload;
  try {
    const res = yield call(requestArchiveOrder, { 'Order ID': values.ID });
    yield put(archiveOrderSuccess({
      ID: values.ID,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Order successfully archived',
      variant: 'success',
    }));
  } catch (err) {
    yield put(archiveOrderFail({
      ...err.data,
      triggerLoading,
    }));
    yield put(addNotification({
      message: err.data && err.data.description ? err.data.description : 'Failed to archive order',
      variant: 'warning',
    }));
  }
}

function* unarchiveOrderSaga(action) {
  const { triggerLoading, values } = action.payload;
  try {
    const res = yield call(requestUnarchiveOrder, { 'Order ID': values.ID });
    yield put(unarchiveOrderSuccess({
      ID: values.ID,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Order successfully extracted from archive',
      variant: 'success',
    }));
  } catch (err) {
    yield put(archiveOrderFail({
      ...err.data,
      triggerLoading,
    }));
    yield put(addNotification({
      message: err.data && err.data.description ? err.data.description : 'Failed to extract order from archive',
      variant: 'warning',
    }));
  }
}

function* deleteArchiveOrderSaga(action) {
  const { triggerLoading, ID } = action.payload;
  try {
    const res = yield call(requestDeleteArchiveOrder, ID);
    yield put(deleteArchiveOrderSuccess({
      ID,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Order successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deleteArchiveOrderFail({
      ...err.data,
      triggerLoading,
    }));
    yield put(addNotification({
      message: 'Failed to delete order',
      variant: 'warning',
    }));
  }
}

export function* archiveOrdersSaga() {
  yield takeLatest(FETCH_ARCHIVE_ORDERS, fetchArchiveOrdersSaga);
  yield takeEvery(FETCH_ARCHIVE_ORDER, fetchArchiveOrderSaga);
  yield takeEvery(DELETE_ARCHIVE_ORDER, deleteArchiveOrderSaga);
  yield takeEvery(ARCHIVE_ORDER, archiveOrderSaga);
  yield takeEvery(UNARCHIVE_ORDER, unarchiveOrderSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/archiveOrders.js